import type { FragViewerLoadStatus } from "./types";

type LoadStatusOverlayProps = {
  status: FragViewerLoadStatus | null;
};

export function LoadStatusOverlay({ status }: LoadStatusOverlayProps) {
  if (!status) return null;

  return (
    <div style={{
      position: "absolute",
      inset: status.blocking ? 0 : "auto 16px 16px auto",
      zIndex: 30,
      display: "flex",
      alignItems: status.blocking ? "center" : "flex-end",
      justifyContent: status.blocking ? "center" : "flex-end",
      background: status.blocking ? "rgba(8, 12, 28, 0.42)" : "transparent",
      pointerEvents: "none",
    }}>
      <div style={{
        width: status.blocking ? "min(340px, calc(100% - 48px))" : 280,
        borderRadius: 6,
        border: status.tone === "error"
          ? "1px solid rgba(248, 113, 113, 0.55)"
          : "1px solid rgba(148, 163, 184, 0.3)",
        background: status.tone === "error"
          ? "rgba(69, 10, 10, 0.92)"
          : "rgba(15, 23, 42, 0.9)",
        color: "#f8fafc",
        boxShadow: "0 18px 45px rgba(0, 0, 0, 0.28)",
        padding: "14px 16px",
        fontSize: 13,
        lineHeight: 1.45,
      }}>
        <div style={{ fontWeight: 700, marginBottom: status.detail ? 4 : 0 }}>
          {status.title}
        </div>
        {status.detail && (
          <div style={{ color: "#cbd5e1", overflowWrap: "anywhere" }}>
            {status.detail}
          </div>
        )}
      </div>
    </div>
  );
}
